import { styled } from '@mui/material'
import Miles from 'assets/branding/miles.svg'

export const MilesRepublicLogo = styled(Miles)({ width: 110 })
